// proto/v2/skill/skill.proto
//
// Skills over WS. Covers two tranches:
//
//   Wave 2 — post-finalization enhancement (applied to an already-finalized
//   report node):
//     GET  /api/v1/research/:id/enhance/available → ListAvailableEnhancementsRequest
//     POST /api/v1/research/:id/enhance/:skill    → RunEnhancementRequest
//
//   Wave 3b — global per-user skill catalog (CRUD + prefs + AI-generation):
//     GET    /api/v1/skills              → ListSkillsRequest
//     POST   /api/v1/skills              → CreateSkillRequest  (YAML opaque)
//     PUT    /api/v1/skills/:id          → UpdateSkillRequest  (YAML opaque)
//     DELETE /api/v1/skills/:id          → DeleteSkillRequest
//     PATCH  /api/v1/skills/:id/prefs    → UpdateSkillPrefsRequest (typed)
//     POST   /api/v1/skills/generate     → GenerateSkillRequest
//
// YAML deliberately stays opaque on the wire for Create/Update: the skill
// format is still evolving and a typed proto would block iteration. Prefs,
// by contrast, are stable structured state and get a typed schema.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file skill/skill.proto (package lvdr.v2.skill, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file skill/skill.proto.
 */
export const file_skill_skill: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * A single skill that can be applied to a finalized report.
 *
 * @generated from message lvdr.v2.skill.EnhancementSkill
 */
export type EnhancementSkill = Message<"lvdr.v2.skill.EnhancementSkill"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: double estimated_cost_usd = 4;
   */
  estimatedCostUsd: number;

  /**
   * @generated from field: int32 estimated_duration_sec = 5;
   */
  estimatedDurationSec: number;

  /**
   * estimated_cost_credits is the user-facing presentation of estimated_cost_usd,
   * converted server-side via the shared billing pricing. The FE renders this,
   * never the dollar figure. 0 when billing pricing is unwired.
   *
   * @generated from field: int64 estimated_cost_credits = 6;
   */
  estimatedCostCredits: bigint;
};

/**
 * Describes the message lvdr.v2.skill.EnhancementSkill.
 * Use `create(EnhancementSkillSchema)` to create a new message.
 */
export const EnhancementSkillSchema: GenMessage<EnhancementSkill> = /*@__PURE__*/
  messageDesc(file_skill_skill, 0);

/**
 * List skills applicable to post-finalization enhancement for this research.
 * (Registry is global today; research_id is included for future per-research
 * filtering and audit trail.)
 *
 * @generated from message lvdr.v2.skill.ListAvailableEnhancementsRequest
 */
export type ListAvailableEnhancementsRequest = Message<"lvdr.v2.skill.ListAvailableEnhancementsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.skill.ListAvailableEnhancementsRequest.
 * Use `create(ListAvailableEnhancementsRequestSchema)` to create a new message.
 */
export const ListAvailableEnhancementsRequestSchema: GenMessage<ListAvailableEnhancementsRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 1);

/**
 * @generated from message lvdr.v2.skill.ListAvailableEnhancementsResponse
 */
export type ListAvailableEnhancementsResponse = Message<"lvdr.v2.skill.ListAvailableEnhancementsResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.skill.EnhancementSkill skills = 2;
   */
  skills: EnhancementSkill[];
};

/**
 * Describes the message lvdr.v2.skill.ListAvailableEnhancementsResponse.
 * Use `create(ListAvailableEnhancementsResponseSchema)` to create a new message.
 */
export const ListAvailableEnhancementsResponseSchema: GenMessage<ListAvailableEnhancementsResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 2);

/**
 * Run a skill against an already-finalized report node. Creates a new
 * "enhanced" report node as a sibling.
 *
 * @generated from message lvdr.v2.skill.RunEnhancementRequest
 */
export type RunEnhancementRequest = Message<"lvdr.v2.skill.RunEnhancementRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string skill_id = 2;
   */
  skillId: string;

  /**
   * @generated from field: string source_node_id = 3;
   */
  sourceNodeId: string;
};

/**
 * Describes the message lvdr.v2.skill.RunEnhancementRequest.
 * Use `create(RunEnhancementRequestSchema)` to create a new message.
 */
export const RunEnhancementRequestSchema: GenMessage<RunEnhancementRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 3);

/**
 * @generated from message lvdr.v2.skill.RunEnhancementResponse
 */
export type RunEnhancementResponse = Message<"lvdr.v2.skill.RunEnhancementResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * newly created enhanced report node
   *
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string skill_id = 3;
   */
  skillId: string;
};

/**
 * Describes the message lvdr.v2.skill.RunEnhancementResponse.
 * Use `create(RunEnhancementResponseSchema)` to create a new message.
 */
export const RunEnhancementResponseSchema: GenMessage<RunEnhancementResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 4);

/**
 * SkillContext describes one context configuration slot (e.g. "research",
 * "post_finalization"). `enabled` is the effective value after applying
 * user prefs on top of the YAML default.
 *
 * @generated from message lvdr.v2.skill.SkillContext
 */
export type SkillContext = Message<"lvdr.v2.skill.SkillContext"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: double estimated_cost_usd = 2;
   */
  estimatedCostUsd: number;

  /**
   * @generated from field: int32 estimated_duration_sec = 3;
   */
  estimatedDurationSec: number;

  /**
   * estimated_cost_credits mirrors estimated_cost_usd converted to credits
   * server-side via the shared billing pricing. The FE renders this, never the
   * dollar figure. 0 when billing pricing is unwired.
   *
   * @generated from field: int64 estimated_cost_credits = 4;
   */
  estimatedCostCredits: bigint;
};

/**
 * Describes the message lvdr.v2.skill.SkillContext.
 * Use `create(SkillContextSchema)` to create a new message.
 */
export const SkillContextSchema: GenMessage<SkillContext> = /*@__PURE__*/
  messageDesc(file_skill_skill, 5);

/**
 * SkillSetting is one user-tunable integer-valued knob. Matches
 * SkillSettingDTO in internal/skills/global_handler.go; day-1 is integer-only.
 *
 * @generated from message lvdr.v2.skill.SkillSetting
 */
export type SkillSetting = Message<"lvdr.v2.skill.SkillSetting"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * "integer" today
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: int32 default_value = 3;
   */
  defaultValue: number;

  /**
   * user override or default_value
   *
   * @generated from field: int32 value = 4;
   */
  value: number;

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message lvdr.v2.skill.SkillSetting.
 * Use `create(SkillSettingSchema)` to create a new message.
 */
export const SkillSettingSchema: GenMessage<SkillSetting> = /*@__PURE__*/
  messageDesc(file_skill_skill, 6);

/**
 * Skill is the full skill representation returned by ListSkills. System
 * skills come from the registry; user skills are authored YAML in settings.db.
 * `raw_yaml` is only populated for user skills (for edit-in-place support).
 *
 * @generated from message lvdr.v2.skill.Skill
 */
export type Skill = Message<"lvdr.v2.skill.Skill"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * "system" | "user"
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * empty for system skills
   *
   * @generated from field: string raw_yaml = 5;
   */
  rawYaml: string;

  /**
   * @generated from field: map<string, lvdr.v2.skill.SkillContext> contexts = 6;
   */
  contexts: { [key: string]: SkillContext };

  /**
   * @generated from field: repeated lvdr.v2.skill.SkillSetting settings = 7;
   */
  settings: SkillSetting[];
};

/**
 * Describes the message lvdr.v2.skill.Skill.
 * Use `create(SkillSchema)` to create a new message.
 */
export const SkillSchema: GenMessage<Skill> = /*@__PURE__*/
  messageDesc(file_skill_skill, 7);

/**
 * SkillPrefs mirrors internal/skills.SkillPrefs — per-user overrides stored
 * in settings.db. Merged on top of YAML defaults in List.
 *
 * @generated from message lvdr.v2.skill.SkillPrefs
 */
export type SkillPrefs = Message<"lvdr.v2.skill.SkillPrefs"> & {
  /**
   * @generated from field: map<string, bool> contexts = 1;
   */
  contexts: { [key: string]: boolean };

  /**
   * @generated from field: map<string, int32> settings = 2;
   */
  settings: { [key: string]: number };
};

/**
 * Describes the message lvdr.v2.skill.SkillPrefs.
 * Use `create(SkillPrefsSchema)` to create a new message.
 */
export const SkillPrefsSchema: GenMessage<SkillPrefs> = /*@__PURE__*/
  messageDesc(file_skill_skill, 8);

/**
 * --- ListSkills ---
 *
 * @generated from message lvdr.v2.skill.ListSkillsRequest
 */
export type ListSkillsRequest = Message<"lvdr.v2.skill.ListSkillsRequest"> & {
};

/**
 * Describes the message lvdr.v2.skill.ListSkillsRequest.
 * Use `create(ListSkillsRequestSchema)` to create a new message.
 */
export const ListSkillsRequestSchema: GenMessage<ListSkillsRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 9);

/**
 * @generated from message lvdr.v2.skill.ListSkillsResponse
 */
export type ListSkillsResponse = Message<"lvdr.v2.skill.ListSkillsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.skill.Skill skills = 1;
   */
  skills: Skill[];
};

/**
 * Describes the message lvdr.v2.skill.ListSkillsResponse.
 * Use `create(ListSkillsResponseSchema)` to create a new message.
 */
export const ListSkillsResponseSchema: GenMessage<ListSkillsResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 10);

/**
 * --- CreateSkill (YAML opaque) ---
 *
 * @generated from message lvdr.v2.skill.CreateSkillRequest
 */
export type CreateSkillRequest = Message<"lvdr.v2.skill.CreateSkillRequest"> & {
  /**
   * @generated from field: string yaml_source = 1;
   */
  yamlSource: string;
};

/**
 * Describes the message lvdr.v2.skill.CreateSkillRequest.
 * Use `create(CreateSkillRequestSchema)` to create a new message.
 */
export const CreateSkillRequestSchema: GenMessage<CreateSkillRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 11);

/**
 * @generated from message lvdr.v2.skill.SkillResponse
 */
export type SkillResponse = Message<"lvdr.v2.skill.SkillResponse"> & {
  /**
   * @generated from field: lvdr.v2.skill.Skill skill = 1;
   */
  skill?: Skill | undefined;
};

/**
 * Describes the message lvdr.v2.skill.SkillResponse.
 * Use `create(SkillResponseSchema)` to create a new message.
 */
export const SkillResponseSchema: GenMessage<SkillResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 12);

/**
 * --- UpdateSkill (YAML opaque) ---
 *
 * @generated from message lvdr.v2.skill.UpdateSkillRequest
 */
export type UpdateSkillRequest = Message<"lvdr.v2.skill.UpdateSkillRequest"> & {
  /**
   * @generated from field: string skill_id = 1;
   */
  skillId: string;

  /**
   * @generated from field: string yaml_source = 2;
   */
  yamlSource: string;
};

/**
 * Describes the message lvdr.v2.skill.UpdateSkillRequest.
 * Use `create(UpdateSkillRequestSchema)` to create a new message.
 */
export const UpdateSkillRequestSchema: GenMessage<UpdateSkillRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 13);

/**
 * --- DeleteSkill ---
 *
 * @generated from message lvdr.v2.skill.DeleteSkillRequest
 */
export type DeleteSkillRequest = Message<"lvdr.v2.skill.DeleteSkillRequest"> & {
  /**
   * @generated from field: string skill_id = 1;
   */
  skillId: string;
};

/**
 * Describes the message lvdr.v2.skill.DeleteSkillRequest.
 * Use `create(DeleteSkillRequestSchema)` to create a new message.
 */
export const DeleteSkillRequestSchema: GenMessage<DeleteSkillRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 14);

/**
 * @generated from message lvdr.v2.skill.DeleteSkillResponse
 */
export type DeleteSkillResponse = Message<"lvdr.v2.skill.DeleteSkillResponse"> & {
  /**
   * @generated from field: string skill_id = 1;
   */
  skillId: string;
};

/**
 * Describes the message lvdr.v2.skill.DeleteSkillResponse.
 * Use `create(DeleteSkillResponseSchema)` to create a new message.
 */
export const DeleteSkillResponseSchema: GenMessage<DeleteSkillResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 15);

/**
 * --- UpdateSkillPrefs (typed) ---
 *
 * @generated from message lvdr.v2.skill.UpdateSkillPrefsRequest
 */
export type UpdateSkillPrefsRequest = Message<"lvdr.v2.skill.UpdateSkillPrefsRequest"> & {
  /**
   * @generated from field: string skill_id = 1;
   */
  skillId: string;

  /**
   * @generated from field: lvdr.v2.skill.SkillPrefs prefs = 2;
   */
  prefs?: SkillPrefs | undefined;
};

/**
 * Describes the message lvdr.v2.skill.UpdateSkillPrefsRequest.
 * Use `create(UpdateSkillPrefsRequestSchema)` to create a new message.
 */
export const UpdateSkillPrefsRequestSchema: GenMessage<UpdateSkillPrefsRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 16);

/**
 * @generated from message lvdr.v2.skill.SkillPrefsResponse
 */
export type SkillPrefsResponse = Message<"lvdr.v2.skill.SkillPrefsResponse"> & {
  /**
   * @generated from field: string skill_id = 1;
   */
  skillId: string;

  /**
   * @generated from field: lvdr.v2.skill.SkillPrefs prefs = 2;
   */
  prefs?: SkillPrefs | undefined;
};

/**
 * Describes the message lvdr.v2.skill.SkillPrefsResponse.
 * Use `create(SkillPrefsResponseSchema)` to create a new message.
 */
export const SkillPrefsResponseSchema: GenMessage<SkillPrefsResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 17);

/**
 * --- GenerateSkill ---
 *
 * @generated from message lvdr.v2.skill.GenerateSkillRequest
 */
export type GenerateSkillRequest = Message<"lvdr.v2.skill.GenerateSkillRequest"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;
};

/**
 * Describes the message lvdr.v2.skill.GenerateSkillRequest.
 * Use `create(GenerateSkillRequestSchema)` to create a new message.
 */
export const GenerateSkillRequestSchema: GenMessage<GenerateSkillRequest> = /*@__PURE__*/
  messageDesc(file_skill_skill, 18);

/**
 * @generated from message lvdr.v2.skill.GenerateSkillResponse
 */
export type GenerateSkillResponse = Message<"lvdr.v2.skill.GenerateSkillResponse"> & {
  /**
   * @generated from field: string yaml = 1;
   */
  yaml: string;
};

/**
 * Describes the message lvdr.v2.skill.GenerateSkillResponse.
 * Use `create(GenerateSkillResponseSchema)` to create a new message.
 */
export const GenerateSkillResponseSchema: GenMessage<GenerateSkillResponse> = /*@__PURE__*/
  messageDesc(file_skill_skill, 19);

